package com.havn.app.core.media

class HavnFilePicker(
    private val pickFile: ((HavnPickedFile?) -> Unit) -> Unit
) {
    fun pick(onResult: (HavnPickedFile?) -> Unit) {
        pickFile(onResult)
    }

    companion object {
        val Unavailable = HavnFilePicker { onResult -> onResult(null) }
    }
}

data class HavnPickedFile(
    val fileName: String,
    val bytes: ByteArray,
    val contentType: String
)
